import { RouterEnum } from '@interface/public';
import RE from '@module/regexp';

/**
 * 配置
 */
export default class Config {
  public static readonly Cookie = { // Cookie
    domain: RE.Format.IPV4.test(location.hostname) // 域名
      ? ''
      : location.hostname.split('.').slice(-2).join('.'),
    time: 24 * 7 // SSO保存时间（小时）
  };
  public static readonly Console = { // 控制台
    log: '/////-' // 日志
  };
  public static readonly Href = { // 链接
    ...(
      $ENV.isFormal
        ? { // 正式服
          sso: 'https://sso.galaxy-future.com', // SSO
          official: 'https://www.galaxy-future.com', // 官网
          store: 'https://apps.galaxy-future.com', // 云应用市场
          cloud: 'https://cloud.galaxy-future.com', // 云托管平台
          cloudDemo: 'https://ifs.galaxy-future.com', // 云托管平台（Demo）
          console: 'https://console.galaxy-future.com', // Console
          dtexpress: 'https://dtexpress.galaxy-future.com', // 数据物流
          activity: 'https://activity.galaxy-future.com' // Activity
        }
        : { // 测试服
          sso: 'http://172.16.16.182:30081', // SSO
          official: 'http://172.16.16.180:30080', // 官网
          store: 'http://172.16.16.180:30090', // 云应用市场
          cloud: 'http://172.16.16.180:30092', // 云托管平台
          cloudDemo: 'http://172.16.16.180:18080', // 云托管平台（Demo）
          console: 'http://172.16.16.180:32003', // Console
          dtexpress: 'http://172.16.16.180:32094', // 数据物流
          activity: 'http://172.16.16.180:30082' // Activity
        }
    ),
    gss: 'https://gss.galaxy-future.com/#/cost/analysis' // GSS
  };
  public static readonly Page = { // 页面
    default: RouterEnum.SSOIndex, // 默认页面
    size: 'small' // 尺寸
  };
  public static readonly ID = { // 标识
    weChatServer: 'wx2e932e5432cf7e35',
    weChatWebApp: 'wx316edd4c642f972d',
    weChatApplet: 'wx2c27aa5c975a77e7',
    feiShu: 'be1d3001-3e6d-461f-8105-afb22a146e9b'
  };
  public static readonly Protocol = { // 协议
    user: 'https://img3.galaxy-future.com/files/%E7%94%A8%E6%88%B7%E6%B3%A8%E5%86%8C%E5%8D%8F%E8%AE%AEv20231212.pdf',
    privacy: 'https://img3.galaxy-future.com/files/privacy.html',
    disclaimers: 'https://img3.galaxy-future.com/files/%E5%85%8D%E8%B4%A3%E5%A3%B0%E6%98%8Ev20231212.pdf'
  };
}